jQuery(function ($) {

    //ページトップに戻るボタンの表示制御
    let topButtonArea=$(".footer__to-top");
    let topButton=$(".footer__to-top-button");
    topButtonArea.hide();　//ボタンを非表示にする
    $(window).on("scroll", function () {
        if ($(this).scrollTop() > 100) { //ページの上から100pxスクロールした時
            topButtonArea.fadeIn("fast"); //ボタンがフェードインする
        } else {
            topButtonArea.fadeOut("fast");　//ボタンがフェードアウトする
        }

        let footerElement = document.querySelector('#footer');;
        let footerRectTop = window.pageYOffset + footerElement.getBoundingClientRect().top;
        let vh = window.innerHeight;

        if ( window.pageYOffset >= footerRectTop - vh ) { //フッターに差し掛かった場合
            topButtonArea.css({
                "position": "static",
            });
        } else { //それ以外の場合は
            topButtonArea.css({
                "position": "fixed", //固定表示
            });
        }
    });
 
    //スムーススクロール設定
    topButton.on('click' ,function () {
        $('body,html').animate({
            scrollTop: 0
        }, 800);　//スムーススクロールの速度
        return false;
    });
});